import React from "react";

const HomePage = () => {
  return (
    <div>
      <h1>Welcome to Xplorizz!</h1>
    </div>
  );
};

export default HomePage;
